import request from '@/utils/request'

let AdApi = {
  /*列表*/
   adList(data) {
    return request._post('/shop/plus.ad.ad/index', data);
  },
  /*添加*/
  addAd(data) {
    return request._post('/shop/plus.ad.ad/add', data);
  },
  /*获取数据*/
  getAd(data) {
    return request._get('/shop/plus.ad.ad/edit', data);
  },
  /*保存*/
  saveAd(data) {
    console.log(data)
    return request._post('/shop/plus.ad.ad/edit', data);
  },
  /*删除*/
  delAd(data) {
    return request._post('/shop/plus.ad.ad/delete', data);
  },
  // 获取广告位置
  getPositionList(data) {
    return request._post('/shop/plus.ad.ad/getPositionList', data);
  },

  //获取购买记录
  recordList(data) {
    return request._post('/shop/plus.ad.ad/recordList', data);
  },
  //获取可购买的广告
  isBuyRecordList(data) {
    return request._post('/shop/plus.ad.ad/isBuyRecordList', data);
  },
  //获取广告详情
  getAdDetail(data){
    return request._post('/shop/plus.ad.ad/getAdDetail', data);
  },
  //购买广告
  buyAd(data){
    return request._post('/shop/plus.ad.ad/buyAd', data);
  },
  //获取购买广告记录详情
  getAdRecordDetail(data){
    return request._post('/shop/plus.ad.ad/getAdRecordDetail', data);
  },
  //修改我购买的广告
  editAd(data){
    return request._post('/shop/plus.ad.ad/editAd', data);
  }
}
export default AdApi;



// WEBPACK FOOTER //
// ./src/api/ad.js